import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var ReloadSVG = function ReloadSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M28.68 19.05a1 1 0 00-1.26.64A12 12 0 1125.75 9H22a1 1 0 000 2h6a1 1 0 00.99-.84l1-6A1 1 0 0028 3.84l-.66 3.97a14 14 0 101.97 12.5 1 1 0 00-.64-1.26z"
  }));
};
ReloadSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ReloadSVG);